import Container from '@mui/material/Container';
import { useEffect, lazy, Suspense } from 'react';
import ScholarInboxApp from './routes/ScholarInboxApp';
import {
  createBrowserRouter,
  createRoutesFromElements,
  Route,
  RouterProvider,
} from "react-router-dom";

const ScholarMapsPage = lazy(() => import('./pages/ScholarMapsPage'));

export default function App() {
  const hostname = window.location.hostname;
  const isScholarMaps = hostname.includes('scholar-maps.com');
  let routeElement;

  useEffect(() => {
    document.title = isScholarMaps ? 'Scholar Maps by Scholar Inbox' : 'Scholar Inbox';
  }, []);
  
  if (isScholarMaps) {
    window.location.href = 'https://scholar-inbox.com/scholar-maps';
    return;
    routeElement = (
      <Route path='*' element={
        <Suspense fallback={<div>Loading...</div>}>
          <ScholarMapsPage mode="logout" isMapDedicated={isScholarMaps} />
        </Suspense>
      } />
    );
  } else
    routeElement = <Route path='*' element={<ScholarInboxApp />} />;

  const router = createBrowserRouter(
    createRoutesFromElements(routeElement)
  );

  return (
    <Container maxWidth={false}>
      <RouterProvider router={router} />
    </Container>
  );
}